import type { SearchFilterEvent } from './SearchFiltersEvent';
import { searchFiltersSchema } from './SearchFiltersSchema';

type Props = {
  price__gte?: string;
  price__lte?: string;
  model?: string[];
  make?: string[];
  sort?: string;
  postcode?: string;
  'variant-type'?: string[];
  'body-type'?: string[];
  doors?: string[];
  seats?: string[];
  year__lte?: string;
  year__gte?: string;
  fueltype?: string[];
  gearbox?: string[];
  maxdistance?: string;
  ecom?: string;
  d2c?: string;
  'new-car-eu24'?: string;
};

export const searchFiltersToEvent = ({
  sort,
  postcode,
  make,
  model,
  price__gte,
  price__lte,
  'variant-type': variantType,
  'body-type': bodyType,
  year__gte,
  year__lte,
  fueltype,
  doors,
  gearbox,
  maxdistance,
  seats,
  ecom,
  d2c,
  'new-car-eu24': newCarEu24,
}: Props): SearchFilterEvent => {
  const event: SearchFilterEvent = {
    schema: searchFiltersSchema.ref,
    data: {
      sort_order: sort,
      distance: maxdistance ? +maxdistance : undefined,
      postcode,
      make,
      model,
      variant: variantType ?? undefined,
      body_type: bodyType,
      total_price_from: price__gte ? +price__gte : undefined,
      total_price_to: price__lte ? +price__lte : undefined,
      model_year_from: year__gte ? +year__gte : undefined,
      model_year_to: year__lte ? +year__lte : undefined,
      fuel_type: fueltype,
      gearbox,
      doors: doors ? +doors : undefined,
      seats: seats ? +seats : undefined,
      buy_online: ecom ? JSON.parse(ecom) : undefined,
      only_from_heycar: d2c ? JSON.parse(d2c) : undefined,
      new_car_eu24: newCarEu24 ? JSON.parse(newCarEu24) : undefined,
    },
  };

  return event;
};
